export default __webpack_public_path__ + "static/award-3-pe-cd4c14747968a1562109196f4d65fe7e.png";